import type { Clock } from "../types";

/** 固定步长模拟时钟。仅在调用 `tick` 时推进。 */
export class GameClock implements Clock {
  private timeSeconds = 0;

  tick(dt: number): void {
    if (dt < 0) {
      throw new Error(`GameClock.tick: dt must be >= 0, got ${dt}`);
    }
    this.timeSeconds += dt;
  }

  time(): number {
    return this.timeSeconds;
  }

  reset(): void {
    this.timeSeconds = 0;
  }

  /** 恢复已校验的模拟时间，用于运行态快照加载。 */
  restore(timeSeconds: number): void {
    if (!Number.isFinite(timeSeconds) || timeSeconds < 0) {
      throw new Error(`GameClock.restore: invalid time ${timeSeconds}`);
    }
    this.timeSeconds = timeSeconds;
  }
}
